import React from 'react';
import PropTypes from 'prop-types';
import { HeaderAuth } from './HeaderAuth';

export function Template ({ children }) {
  return (
    <>
      <HeaderAuth />
      <main className="content-home">
        {children}
      </main>

    </>
  );
}

Template.propTypes = {
  children: PropTypes.node.isRequired,
};
